import { Component, Input } from '@angular/core';
import { getFeatureFlag } from 'src/app/core/services/feature-flag-helpers';
import { EFeatureFlag } from 'src/app/core/services/feature-flags-consts';
import { EIconPath } from 'src/app/project/shared/enums/icons.enum';
import { TWhiteLabelPanelColors, TWhiteLabelPrimaryColors, TWhiteLabelStore } from '../../white-label.model';
import { getDefaultPanelColors } from '../../white-label-utils/get-default-panel-colors';
import { getDefaultPrimaryColors } from '../../white-label-utils/get-default-primary-colors';
import { resolvePrimary950 } from '../../white-label-utils/resolve-primary-950';

@Component({
    selector: 'pp-white-label-preview',
    templateUrl: './white-label-preview.component.html',
    styleUrls: ['./white-label-preview.component.scss'],
    standalone: false
})
export class WhiteLabelPreviewComponent {
  @Input() ppWhiteLabel: TWhiteLabelStore;
  @Input() ppWebLogoImages: File[];
  @Input() ppWebLogoData: string;

  logoSrc: string = null;
  logoBuffer: string | ArrayBuffer = null;
  EIconPath = EIconPath;

  get rebrandEnabled(): boolean {
    return getFeatureFlag(EFeatureFlag.REBRAND);
  }

  get defaultPanelColors(): TWhiteLabelPanelColors {
    return getDefaultPanelColors();
  }

  get defaultPrimaryColors(): TWhiteLabelPrimaryColors {
    return getDefaultPrimaryColors();
  }

  get activeIconColor(): string {
    const { iconActiveColorPanel } = this.ppWhiteLabel.data;

    if (iconActiveColorPanel) {
      return iconActiveColorPanel;
    }

    return resolvePrimary950(this.ppWhiteLabel.data);
  }

  ngOnChanges() {
    if (this.ppWebLogoImages) {
      const reader = new FileReader();

      reader.onload = (): void => {
        this.logoBuffer = reader.result;
        this.logoSrc = null;
      };

      reader.readAsDataURL(this.ppWebLogoImages[0]);
    } else if (this.ppWebLogoData) {
      this.logoSrc = 'api/v1/images/' + this.ppWebLogoData + '/file/size/bounded/400';
      this.logoBuffer = null;
    } else {
      this.logoSrc = null;
      this.logoBuffer = null;
    }
  }
}
